import React from 'react'
import withIconStyles from '@edulastic/icons/src/HOC/withIconStyles'
import SVG from '@edulastic/icons/src/common/SVG'

const IconAlignJustify = (props) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="14.909"
    height="11.714"
    viewBox="0 0 14.909 11.714"
    {...props}
  >
    <g transform="translate(0 -54.817)">
      <g transform="translate(0 54.817)">
        <path
          d="M14.376,274.088H.532a.512.512,0,0,0-.374.158A.512.512,0,0,0,0,274.62v1.065a.512.512,0,0,0,.158.374.512.512,0,0,0,.374.158H14.376a.54.54,0,0,0,.533-.533V274.62a.54.54,0,0,0-.533-.532Z"
          transform="translate(0 -267.699)"
        />
        <path
          d="M14.376,383.721H.532a.512.512,0,0,0-.374.158.512.512,0,0,0-.158.374v1.065a.512.512,0,0,0,.158.375.513.513,0,0,0,.374.158H14.376a.54.54,0,0,0,.533-.533v-1.065a.54.54,0,0,0-.533-.532Z"
          transform="translate(0 -374.137)"
        />
        <path
          d="M14.751,54.975a.513.513,0,0,0-.374-.158H.532a.512.512,0,0,0-.374.158A.512.512,0,0,0,0,55.349v1.065a.512.512,0,0,0,.158.374.512.512,0,0,0,.374.158H14.376a.54.54,0,0,0,.533-.532V55.349A.513.513,0,0,0,14.751,54.975Z"
          transform="translate(0 -54.817)"
        />
        <path
          d="M14.376,164.456H.532a.512.512,0,0,0-.374.158.512.512,0,0,0-.158.374v1.065a.512.512,0,0,0,.158.374.512.512,0,0,0,.374.158H14.376a.54.54,0,0,0,.533-.532v-1.065a.54.54,0,0,0-.533-.532Z"
          transform="translate(0 -161.261)"
        />
      </g>
    </g>
  </SVG>
)

export default withIconStyles(IconAlignJustify)
